import React, { useRef, useEffect } from 'react'

import { useTimeline } from '../hooks/animation'
import { TweenMax, SplitText, Power4 } from '../lib/gsap'

function shuffle(o) {
  for (
    var j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i, 10), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o
}

const splitAndShuffle = text => {
  /* eslint-disable */
  const newText = new SplitText(text, { type: 'words, chars' })
  shuffle(newText.chars)

  return newText
  /* eslint-enable */
}

const WordsRotator = ({ words, ...props }) => {
  const tl = useTimeline({ repeat: -1 })
  const ref = useRef()

  useEffect(() => {
    Array.prototype.forEach.call(ref.current.childNodes, word => {
      const { chars } = splitAndShuffle(word)

      TweenMax.set(chars, {
        x: 40,
        opacity: 0,
        transformOrigin: 'center',
        willChange: 'transform, opacity',
        ease: Power4.easeInOut,
      })

      tl.staggerTo(chars, 0.8, { opacity: 1, x: 0 }, 0.05)
      tl.staggerTo(chars, 0.8, { opacity: 0 }, 0.05, '+=3')
    })
  }, [])

  return (
    <span
      ref={ref}
      css={{
        display: 'inline-block',
        position: 'relative',
        '> span:not(:last-child)': {
          position: 'absolute',
          top: 0,
          left: 0,
        },
      }}
      {...props}
    >
      {words.map(textItem => (
        <span key={textItem}>{textItem}</span>
      ))}
    </span>
  )
}

export default WordsRotator
